import {Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {ForgotPassword} from "../auth/components/ForgotPassword";

const AuthPage = () => (
    <Routes>
        <Route element={<AuthLayout/>}>
            <Route path='login' element={<Login/>}/>
            <Route path='forgot-password' element={<ForgotPassword/>}/>
            <Route index element={<Login/>}/>
        </Route>
    </Routes>
)

export {AuthPage}
